import { useLayoutEffect, useRef } from "react";

export type DropdownOpenChangeHandler = (open: boolean) => void;

/**
 * 실제로 commit된 dropdown open 상태 전환만 알린다.
 *
 * 이전 상태 ref를 현재 `open`으로 초기화하므로 최초 mount의 `false`는 알리지 않고,
 * callback identity만 바뀐 렌더나 이미 닫힌 상태의 중복 close도 알리지 않는다.
 * layout effect에서 알리면 소비처가 open 시점에 option 순서를 snapshot해 첫 popup paint 전에
 * 고정할 수 있다.
 */
export function useDropdownOpenChange(
  open: boolean,
  onOpenChange: DropdownOpenChangeHandler | undefined,
): void {
  const previousOpenRef = useRef(open);

  useLayoutEffect(() => {
    if (previousOpenRef.current === open) {
      return;
    }

    previousOpenRef.current = open;
    onOpenChange?.(open);
  }, [onOpenChange, open]);
}
